/**
 * @module components\ghTable\dataTable
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Mixins, Inject, Provide, Watch } from "vue-property-decorator";
import TableProperty from "@/components/mixins/table/tableProperty";
import AdaptiveHeight from "@/components/mixins/adaptiveHeight";
import DataRow from "./dataRow/dataRow";
import SlotName from "@/components/mixins/slotName";
import TableLayout from "@/components/mixins/table/backend";
import GhBase from "../../ghBase";

@Component({
  components: {
    DataRow
  }
})
export default class DataTable extends Mixins(
  TableProperty,
  SlotName,
  TableLayout,
  GhBase
) {
  [key: string]: any;

  @Provide()
  private bus = new Vue();

  @Prop()
  private beforeIntial: (
    props: ITableRowProps
  ) => { [key: string]: ITableRowOption };
  @Prop({ default: 40 })
  private spaceToBottom!: number;

  private maxHeight = "400px";

  private drawer = false;

  private selectedItmes: any[] = [];

  private innerPagination: IPagination = { rowsPerPage: 20 };

  @Watch("items")
  private updateItems() {
    this.resize();
  }

  private get Headers() {
    if (this.innerHeaders) {
      return this.innerHeaders.filter(h => !h.hide);
    }
  }

  private input(value) {
    this.$emit("input", value);
  }

  private updatePagination(pagination) {
    this.$emit("update:pagination", pagination);
  }

  @Watch("innerHeaders")
  private subscribeEvents(newHeaders, oldHeaders) {
    let es: string[] = [];
    this.traceAction(newHeaders, action => {
      if (action.event) {
        this.bus.$off(action.event);
        es.push(action.event);
        this.bus.$on(action.event, item => {
          this.$emit(action.event as string, item);
        });
      }
    });
    this.$emit("update:events", es);
  }

  @Watch("selectedItmes")
  private observeSelected() {
    this.$emit("input", this.selectedItmes);
  }

  created() {
    if (this.pagination) {
      this.innerPagination = { ...this.innerPagination, ...this.pagination };
    }

    if (this.headers) {
      this.innerHeaders = [...this.innerHeaders, ...this.headers];
    }

    if (this.value) {
      this.selectedItmes = this.value;
    }

    this.bus.$on("clickRow", props => {
      this.selectedItmes = [];
      this.selectedItmes.push(props.item);
      this.$emit("update:currentModel", props.item);
    });
  }

  private resize() {
    let el = this.$refs.div as Element;

    if (el) {
      let top = el.getBoundingClientRect().top;
      let h = window.innerHeight;
      this.maxHeight = h - top - this.spaceToBottom + "px";
    }
  }

  private navigateToConfig() {
    if (this.tableId) {
      this.navigate("column", { tableId: this.tableId });
      // this.$router.push({
      //   name: "/sys/tableConfig/tableConfig",
      //   params: { tableId: this.tableId }
      // });
    }
  }

  private controlDrawer() {
    this.drawer = !this.drawer;
  }

  destroyed() {
    this.traceAction(this.innerHeaders, action => {
      if (action.event) {
        this.bus.$off(action.event);
        this.$off(action.event);
      }
    });

    this.bus.$off("clickRow");
    this.$off("clickRow");
  }
  private fixRef = "table";
}
